import {Button, Divider} from '@material-ui/core';
import {AlertPayload} from 'Core/ducks/alerts';
import {fromArray, map as mapArray} from 'fp-ts/lib/NonEmptyArray';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import {DateTime} from 'luxon';
import React, {ReactNode} from 'react';
import Modal from 'Shared/components/Modal';
import './AlertsModal.sass';

export type AlertMessage = {
  id?: string;
  title: string;
  description: string;
  startDate: O.Option<DateTime>;
  endDate: O.Option<DateTime>;
};

type AlertsProps = {
  alerts: AlertPayload[];
  hideModal: () => void;
};

const renderMessage = (message: AlertPayload) => (
  <div key={`alert-message-${message.id}`}>
    <p>
      <strong>{message.title}</strong>
    </p>
    <p>{message.description}</p>
    <Divider />
  </div>
);

const renderNoResultsFound = (): ReactNode => (
  <div className="alerts-modal__no-results-message">
    <p>No Alerts Available.</p>
  </div>
);

const renderMessages = (alerts: AlertPayload[]) =>
  pipe(
    alerts,
    fromArray,
    O.fold(renderNoResultsFound, mapArray(renderMessage))
  );

const AlertsModal = (props: AlertsProps) => {
  return (
    <Modal onClose={props.hideModal} open title="Standard Alerts">
      <div className="alerts-modal">
        <div className="alerts-modal__alerts-list">{renderMessages(props.alerts)}</div>
        <Button onClick={props.hideModal} fullWidth variant="contained" color="primary">
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default AlertsModal;
